import _slicedToArray from "/Users/mac/github/elemental-zcash/react/docs/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/Users/mac/github/elemental-zcash/react/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/mac/github/elemental-zcash/react/docs/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { CAM16 } from '../hct/cam16';
import * as utils from '../utils/color_utils';
import * as math from '../utils/math_utils';
/**
 *  Given a large set of colors, remove colors that are unsuitable for a UI
 *  theme, and rank the rest based on suitability.
 *
 *  Enables use of a high cluster count for image quantization, thus ensuring
 *  colors aren't muddied, while curating the high cluster count to a much
 *  smaller number of appropriate choices.
 */

export var Score = /*#__PURE__*/function () {
  function Score() {
    _classCallCheck(this, Score);
  }
  /**
   * Given a map with keys of colors and values of how often the color appears,
   * rank the colors based on suitability for being used for a UI theme.
   *
   * @param colorsToPopulation map with keys of colors and values of how often
   *     the color appears, usually from a source image.
   * @return Colors sorted by suitability for a UI theme. The most suitable
   *     color is the first item, the least suitable is the last. There will
   *     always be at least one color returned. If all the input colors
   *     were not suitable for a theme, a default fallback color will be
   *     provided, Google Blue.
   */


  _createClass(Score, null, [{
    key: "score",
    value: function score(colorsToPopulation) {
      // Determine the total count of all colors.
      var populationSum = 0;

      var _iterator = _createForOfIteratorHelper(colorsToPopulation.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var population = _step.value;
          populationSum += population;
        } // Turn the count of each color into a proportion by dividing by the total
        // count. Also, fill a cache of CAM16 colors representing each color, and
        // record the proportion of colors for each CAM16 hue.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var colorsToProportion = new Map();
      var colorsToCam = new Map();
      var hueProportions = new Array(360).fill(0);

      var _iterator2 = _createForOfIteratorHelper(colorsToPopulation.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              color = _step2$value[0],
              _population = _step2$value[1];

          var proportion = _population / populationSum;
          colorsToProportion.set(color, proportion);
          var cam = CAM16.fromInt(color);
          colorsToCam.set(color, cam);
          var hue = Math.round(cam.hue);
          hueProportions[hue] += proportion;
        } // Determine the proportion of the colors around each color, by summing the
        // proportions around each color's hue.

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var colorsToExcitedProportion = new Map();

      var _iterator3 = _createForOfIteratorHelper(colorsToCam.entries()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              _color = _step3$value[0],
              _cam = _step3$value[1];

          var _hue = Math.round(_cam.hue);

          var excitedProportion = 0;

          for (var i = _hue - 15; i < _hue + 15; i++) {
            var neighborHue = math.sanitizeDegrees(i);
            excitedProportion += hueProportions[neighborHue];
          }

          colorsToExcitedProportion.set(_color, excitedProportion);
        } // Score the colors by their proportion, as well as how chromatic they are.

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var colorsToScore = new Map();

      var _iterator4 = _createForOfIteratorHelper(colorsToCam.entries()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              _color2 = _step4$value[0],
              _cam2 = _step4$value[1];

          var _proportion = colorsToExcitedProportion.get(_color2);

          var proportionScore = _proportion * 100.0 * Score.WEIGHT_PROPORTION;
          var chromaWeight = _cam2.chroma < Score.TARGET_CHROMA ? Score.WEIGHT_CHROMA_BELOW : Score.WEIGHT_CHROMA_ABOVE;
          var chromaScore = (_cam2.chroma - Score.TARGET_CHROMA) * chromaWeight;
          var score = proportionScore + chromaScore;
          colorsToScore.set(_color2, score);
        } // Remove colors that are unsuitable, ex. very dark or unchromatic colors.
        // Also, remove colors that are very similar in hue.

      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var filteredColors = Score.filter(colorsToExcitedProportion, colorsToCam);
      var dedupedColorsToScore = new Map();

      var _iterator5 = _createForOfIteratorHelper(filteredColors),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _color3 = _step5.value;
          var duplicateHue = false;
          var _hue2 = colorsToCam.get(_color3).hue;

          var _iterator6 = _createForOfIteratorHelper(dedupedColorsToScore),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _step6$value = _slicedToArray(_step6.value, 1),
                  alreadyChosenColor = _step6$value[0];

              var alreadyChosenHue = colorsToCam.get(alreadyChosenColor).hue;

              if (math.differenceDegrees(_hue2, alreadyChosenHue) < 15) {
                duplicateHue = true;
                break;
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          if (duplicateHue) {
            continue;
          }

          dedupedColorsToScore.set(_color3, colorsToScore.get(_color3));
        } // Ensure the list of colors returned is sorted such that the first in the
        // list is the most suitable, and the last is the least suitable.

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var colorsByScoreDescending = Array.from(dedupedColorsToScore.entries());
      colorsByScoreDescending.sort(function (first, second) {
        return second[1] - first[1];
      });
      var answer = colorsByScoreDescending.map(function (entry) {
        return entry[0];
      }); // Ensure that at least one color is returned.

      if (answer.length === 0) {
        answer.push(0xff4285F4); // Google Blue
      }

      return answer;
    }
  }, {
    key: "filter",
    value: function filter(colorsToExcitedProportion, colorsToCam) {
      var filtered = new Array();

      var _iterator7 = _createForOfIteratorHelper(colorsToCam.entries()),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _step7$value = _slicedToArray(_step7.value, 2),
              color = _step7$value[0],
              cam = _step7$value[1];

          var proportion = colorsToExcitedProportion.get(color);

          if (cam.chroma >= Score.CUTOFF_CHROMA && utils.lstarFromInt(color) >= Score.CUTOFF_TONE && proportion >= Score.CUTOFF_EXCITED_PROPORTION) {
            filtered.push(color);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return filtered;
    }
  }]);

  return Score;
}();
Score.TARGET_CHROMA = 48.0;
Score.WEIGHT_PROPORTION = 0.7;
Score.WEIGHT_CHROMA_ABOVE = 0.3;
Score.WEIGHT_CHROMA_BELOW = 0.1;
Score.CUTOFF_CHROMA = 15.0;
Score.CUTOFF_TONE = 10.0;
Score.CUTOFF_EXCITED_PROPORTION = 0.01;